import {
  ActionValidation,
  BooleanValidation,
  NumberValidation,
  ObjectValidation,
  StringValidation,
} from '../../../../../utils/component-validations';
import { HIDDEN_SELECTOR } from '../../../../../utils/keyboard-nav-support';
import { ensureSafeComponent } from '@embroider/util';
import { fn, hash } from '@ember/helper';
import { gte } from 'ember-truth-helpers';
import { reads } from 'macro-decorators';
import { tracked } from '@glimmer/tracking';
import CheckboxGroup from '../../group/checkbox.gjs';
import Menu from '../../../core/menu/base.gjs';
import Super from '../../../core/base.gjs';

const SELECT_ALL_LABEL_DEFAULT = 'Select all';
const SELECT_ALL_MIN_DEFAULT = 6;

export default class SpdsInputDropdownListMultiselectMenu extends Super {
  additionalClasses = 'spds-input-dropdown-list-item';
  arguments = [
    new ActionValidation({
      required: ['onClick'],
    }),
    new BooleanValidation({ required: ['open'] }),
    new NumberValidation({ optional: ['selectAllMin'] }),
    new ObjectValidation({ required: ['anchorElement'] }),
    new StringValidation({ optional: ['selectAllLabel'] }),
  ];
  baseClass = 'spds-input-dropdown-list-multiselect-menu';
  componentName = 'Spds::Input::Dropdown::List::MultiselectMenu';

  @tracked checkboxGroup;

  @reads('args.selectAllLabel', SELECT_ALL_LABEL_DEFAULT) selectAllLabel;
  @reads('args.selectAllMin', SELECT_ALL_MIN_DEFAULT) selectAllThreshold;
  @reads('checkboxGroup.selectAllComponent') selectAllComponent;
  @reads('checkboxGroup.navigableOptions', []) navigableOptions;

  get menuId() {
    return this.composeSubcomponentId('multi-menu');
  }

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @animated={{true}}
      @id={{this.id}}
      @open={{@open}}
      @multiselect={{true}}
      class={{this.classes}}
      data-test-spds-input-dropdown-list-multiselect-menu
      {{this.validateArguments}}
      ...attributes
    >
      <CheckboxGroup
        @groupName={{this.menuId}}
        @hideDescription={{true}}
        @id={{this.menuId}}
        @layout="column"
        @onClick={{@onClick}}
        @onSetup={{@onClick}}
        @registerComponent={{fn this.registerComponent "checkboxGroup"}}
        @unregisterComponent={{fn this.unregisterComponent "checkboxGroup"}}
        as |cg|
      >
        <cg.selectAll
          @inputClasses="{{this.additionalClasses}} select-all"
          @label={{this.selectAllLabel}}
          class={{unless (gte cg.optionCount this.selectAllThreshold) HIDDEN_SELECTOR}}
          data-test-spds-input-dropdown-list-multiselect-menu-select-all-option
        />
        {{yield
          (hash
            item=(component (ensureSafeComponent cg.checkbox) inputClasses=this.additionalClasses)
          )
        }}
      </CheckboxGroup>
    </Menu>
  </template>
}
